"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.clear = void 0;
var px_1 = require("./px");
/**
 * Clears a portion of an HMTL5 canvas context.
 * @param ctx The HTML canvas context to clear.
 * @param param1 Attributes defining the rect to clear.
 */
var clear = function (ctx, _a) {
    var x = _a.x, y = _a.y, h = _a.h, w = _a.w, scale = _a.scale;
    var px = (0, px_1.makePx)(scale);
    ctx.clearRect(px(x), px(y), px(w), px(h));
};
exports.clear = clear;
